import { render, staticRenderFns } from "./formtemplateadd.vue?vue&type=template&id=94ee064e&scoped=true"
import script from "./formtemplateadd.vue?vue&type=script&lang=js"
export * from "./formtemplateadd.vue?vue&type=script&lang=js"
import style0 from "./formtemplateadd.vue?vue&type=style&index=0&id=94ee064e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ee064e",
  null
  
)

export default component.exports